export const ReelsIcon = (props: any) => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M49.9622 5.7H26.0377C20.6438 5.7 15.4708 7.84333 11.6567 11.6585C7.84265 15.4736 5.69995 20.6481 5.69995 26.0435V49.9565C5.69995 55.3519 7.84265 60.5264 11.6567 64.3415C15.4708 68.1567 20.6438 70.3 26.0377 70.3H49.9622C55.3561 70.3 60.5291 68.1567 64.3432 64.3415C68.1573 60.5264 70.3 55.3519 70.3 49.9565V26.025C70.2951 20.6328 68.1502 15.4631 64.3366 11.6519C60.5231 7.84078 55.3529 5.69999 49.9622 5.7ZM52.791 39.3223H39.3496V52.7676H36.6872V39.3223H23.2458V36.6222H36.6872V23.1769H39.3866V36.6222H52.828L52.791 39.3223Z"
      fill="#fff"
    />
  </svg>
);
